/** Inline SVG placeholder when a game thumbnail URL fails (no extra network request). */
export const GAME_THUMB_PLACEHOLDER =
  'data:image/svg+xml;charset=utf-8,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="533" viewBox="0 0 400 533">
      <defs>
        <linearGradient id="a" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#1a1612"/>
          <stop offset="100%" style="stop-color:#0c0a08"/>
        </linearGradient>
      </defs>
      <rect fill="url(#a)" width="400" height="533" rx="14"/>
      <g fill="none" stroke="#6b5c3e" stroke-width="2.2" opacity="0.4">
        <rect x="118" y="188" width="164" height="118" rx="10"/>
        <path d="M138 288h124M200 208v88"/>
      </g>
    </svg>`,
  );
